import React from 'react';
import MuiTable from 'components/molecules/MuiTable';
import { MUIDataTableColumnDef, MUIDataTableOptions } from 'mui-datatables';
import textLabels from 'utils/MUIDataTableTextLabels';
import CustomToolbar from 'components/molecules/CustomToolBarMuiDatatable/CustomToolbarMuiDatatable';
import { Button, Grid } from '@material-ui/core';

interface Props {
  providers: any;
  isLoading: boolean;
  handleOnClickEditProvider: (wareHouseId: string) => void;
  addProviderButton: () => void;
}
export default function IMProvidersList({ providers, isLoading, handleOnClickEditProvider, addProviderButton }: Props) {
  const columns: MUIDataTableColumnDef[] = [
    {
      name: 'id',
      label: 'id',
      options: {
        display: 'false'
      }
    },
    {
      name: 'name',
      label: 'Categoría'
    },
    {
      name: 'nit',
      label: 'NIT'
    },
    {
      name: 'status',
      label: 'Estado',
      options: {
        customBodyRender: (value) => {
          if (value) {
            return <div>Activo</div>;
          } else {
            return <div>Inactivo</div>;
          }
        }
      }
    },
    {
      name: '',
      label: 'Acciones',
      options: {
        filter: false,
        sort: false,
        download: false,
        print: false,
        empty: true,
        customBodyRender: (_, tableMeta) => {
          return (
            <Grid container justify="flex-start">
              <Button
                variant="outlined"
                size="small"
                color="primary"
                style={{ marginRight: 5 }}
                onClick={() => {
                  handleOnClickEditProvider(tableMeta.rowData[0]);
                }}
              >
                Editar
              </Button>
            </Grid>
          );
        }
      }
    }
  ];

  const options: MUIDataTableOptions = {
    textLabels,
    download: false,
    filter: false,
    print: false,
    selectableRowsHeader: false,
    selectableRows: 'none',
    viewColumns: false,
    searchOpen: true,
    customToolbar: () => {
      return <CustomToolbar tooltip="Agregar proveedor" onClick={addProviderButton} />;
    }
  };

  return (
    <React.Fragment>
      <div>
        <MuiTable
          title="Listado de Proveedores"
          isLoading={isLoading}
          columns={columns}
          data={providers}
          options={options}
        />
      </div>
    </React.Fragment>
  );
}
